// src/App.js

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SEO from "./components/SEO";

// Páginas para escritorio
import HomeScreen from "./pages/HomeScreen";
import FleetPage from "./pages/FleetPage";
import InfoPage from "./pages/InfoPage";

// Páginas para móviles
import MobileHome from "./mobile/MobileHome";
import FleetMobile from "./components/FleetMobile";
import OurServices from "./components/OurServices";
import MobileReserveRide from "./mobile/MobileReserveRide";
import MobileLocation from "./mobile/MobileLocation";

// Componentes comunes
import Header from "./components/Header";
import Footer from "./components/Footer";

// Modales para escritorio
import ServicesModal from "./components/ServicesModal";
import LocationModal from "./components/LocationModal";
import ContactsModal from "./components/ContactsModal";

// NUEVO: Importamos nuestro MobileReservationButton
import MobileReservationButton from "./components/MobileReservationButton";

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [activeModal, setActiveModal] = useState(null); // "services", "location", "contacts", etc.

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Funciones para abrir/cerrar modales en escritorio
  const openModal = (type) => setActiveModal(type);
  const closeModal = () => setActiveModal(null);

  return (
    <Router>
      <div className={`container ${isMobile ? "mobile-container" : ""}`}>
        <Header openModal={openModal} />

        <Routes>
          {isMobile ? (
            <>
              {/* ---------- RUTAS PARA MÓVIL ---------- */}
              <Route
                path="/"
                element={
                  <>
                    <SEO
                      title="Heritage Car Taxi (Mobile) | 24/7 Airport & City Rides"
                      description="Heritage Car Taxi móvil. Safe, fast, and reliable airport transfers & city rides."
                      url="https://heritagecarairport.com"
                      image="https://heritage-car-airport.vercel.app/home-image.jpg"
                    />
                    <MobileHome />
                  </>
                }
              />
              <Route
                path="/fleet"
                element={
                  <>
                    <SEO
                      title="Luxury Fleet (Mobile) - Heritage Car Taxi"
                      description="Explore our premium fleet in mobile view."
                      url="https://heritagecarairport.com/fleet"
                      image="https://heritage-car-airport.vercel.app/fleet-image.jpg"
                    />
                    <FleetMobile />
                  </>
                }
              />
              <Route
                path="/services"
                element={
                  <>
                    <SEO
                      title="Our Services (Mobile) - Heritage Car Taxi"
                      description="Discover premium services tailored for your travel needs (Mobile)."
                      url="https://heritagecarairport.com/services"
                      image="https://heritage-car-airport.vercel.app/services-image.jpg"
                    />
                    <OurServices />
                  </>
                }
              />
              <Route
                path="/reservations"
                element={
                  <>
                    <SEO
                      title="Book Your Ride (Mobile) - Heritage Car Taxi"
                      description="Reserve your taxi online (Mobile). Fast & reliable service available 24/7."
                      url="https://heritagecarairport.com/reservations"
                      image="https://heritage-car-airport.vercel.app/reservation-image.jpg"
                    />
                    <MobileReserveRide />
                  </>
                }
              />
              <Route
                path="/location"
                element={
                  <>
                    <SEO
                      title="Location (Mobile) - Heritage Car Taxi"
                      description="Find our location and map (Mobile)."
                      url="https://heritagecarairport.com/location"
                      image="https://heritage-car-airport.vercel.app/location-image.jpg"
                    />
                    <MobileLocation />
                  </>
                }
              />
            </>
          ) : (
            <>
              {/* ---------- RUTAS PARA ESCRITORIO ---------- */}
              <Route
                path="/"
                element={
                  <>
                    <SEO
                      title="Heritage Car Taxi | 24/7 Airport & City Rides"
                      description="Heritage Car Taxi (NY DOS ID #7502116). Safe, fast, and reliable airport transfers & city rides."
                      url="https://heritagecarairport.com"
                      image="https://heritage-car-airport.vercel.app/home-image.jpg"
                    />
                    <HomeScreen />
                  </>
                }
              />
              <Route
                path="/fleet"
                element={
                  <>
                    <SEO
                      title="Luxury Fleet - Heritage Car Taxi"
                      description="Explore our premium fleet and book your VIP ride now at Heritage Car Taxi."
                      url="https://heritagecarairport.com/fleet"
                      image="https://heritage-car-airport.vercel.app/fleet-image.jpg"
                    />
                    <FleetPage />
                  </>
                }
              />
              <Route
                path="/info"
                element={
                  <>
                    <SEO
                      title="More Information - Heritage Car Taxi"
                      description="Get more details about our services and locations."
                      url="https://heritagecarairport.com/info"
                      image="https://heritage-car-airport.vercel.app/info-image.jpg"
                    />
                    <InfoPage />
                  </>
                }
              />
            </>
          )}
        </Routes>

        {/* --- MODALES DE ESCRITORIO --- */}
        {!isMobile && activeModal === "services" && (
          <>
            <SEO
              title="Our Services - Heritage Car Taxi"
              description="Discover premium services tailored for your travel needs."
              url="https://heritagecarairport.com/services"
              image="https://heritage-car-airport.vercel.app/services-image.jpg"
            />
            <ServicesModal closeModal={closeModal} />
          </>
        )}
        {!isMobile && activeModal === "reservations" && (
          <>
            <SEO
              title="Book Your Ride - Heritage Car Taxi"
              description="Reserve your taxi online. Fast & reliable service available 24/7."
              url="https://heritagecarairport.com/reservations"
              image="https://heritage-car-airport.vercel.app/reservation-image.jpg"
            />
            {/* <ReservationsModal closeModal={closeModal} /> */}
            {/* Asegúrate de tener un componente ReservationsModal si lo deseas en escritorio */}
          </>
        )}
        {!isMobile && activeModal === "location" && (
          <>
            <SEO
              title="Location - Heritage Car Taxi"
              description="Find our location and map."
              url="https://heritagecarairport.com/location"
              image="https://heritage-car-airport.vercel.app/location-image.jpg"
            />
            <LocationModal closeModal={closeModal} />
          </>
        )}
        {!isMobile && activeModal === "callNow" && (
          <>
            <SEO
              title="Call Now - Heritage Car Taxi"
              description="Contact us immediately via phone."
              url="https://heritagecarairport.com/call"
              image="https://heritage-car-airport.vercel.app/call-image.jpg"
            />
            <ContactsModal closeModal={closeModal} />
          </>
        )}

        {/* --- Si estamos en MÓVIL, mostramos los 3 botones flotantes --- */}
        {isMobile && <MobileReservationButton />}

        <Footer isMobile={isMobile} />
      </div>
    </Router>
  );
}

export default App;
